/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const update_organization_type = /* GraphQL */ `
  mutation Update_organization_type($input: updateOrganizationTypeInputs) {
    update_organization_type(input: $input)
  }
`;
